import React, { useState } from 'react';
import pic from '../assets/img/images.png';
import qrCodeImage from "../assets/img/qr.png";

function NavBar() {
  const [btnState, setBtnState] = useState(false);

  function handleClick() {
    setBtnState(btnState => !btnState);
    document.body.classList.toggle('dark-mode');
  }

  let toggleClassCheck = btnState ? 'bx bx-sun' : 'bx bx-moon';

  return (
    <div>
      <header className="header">
        <a href="#" className="logo">Portfolio</a>

        <nav className="navbar">
          <a href="#" className="active">Home</a>
          <a href="#">About</a>
          <a href="#">Skills</a>
          <a href="#">Resume</a>
          <a href="#">Contact</a>
        </nav>

        <div className={toggleClassCheck} onClick={handleClick} id="darkMode-icon"></div>
      </header>

      <section className="home" id="home">
        <div className="home-content">
          <h3>Hello, I am</h3>
          <h1>Ashiq Noor Sudheer</h1>
          <p>Welcome to my Portfolio Page</p>

          <div className="social-media">
            <a href="https://www.linkedin.com/in/ashiq-noor-sudheer/" target="_blank" rel="noopener noreferrer"><i className='bx bxl-linkedin-square'></i></a>
            <a href="https://www.instagram.com/ashi.i.q/" target="_blank" rel="noopener noreferrer"><i className='bx bxl-instagram'></i></a>
            <a href="https://twitter.com/ashiq_n_sudheer" target="_blank" rel="noopener noreferrer"><i className='bx bxl-twitter'></i></a>
            <a href="https://github.com/AshiqNoor-S" target="_blank" rel="noopener noreferrer"><i className='bx bxl-github'></i></a>
          </div>

          <a href="https://drive.google.com/file/d/1hw0CadceXnCwVh0a8IEuaGpfpXRMpMLQ/view?usp=sharing" className="btn1" download="resume.png">Download Resume</a>
        </div>

        <div className="qr-code">
          <img src={qrCodeImage} alt="QR Code" />
          <div className="qr-text">
            <span>SCAN TO VIEW</span>
            <span>CV</span>
          </div>
        </div>

        <div className="animated-arrow">
          <lottie-player src="https://lottie.host/fcb1c20d-d2a9-4d00-adaf-b70f2a775efb/mAdXnrZUTn.json" background="##FFFFFF" speed="1" style={{ width: 200, height: 200 }}  loop autoplay direction="1" mode="normal"></lottie-player>
          {/* <div className="arrow"></div> */}
        </div>

        {/* <div className="home-img">
          <img src={pic} alt="Profile" />
        </div> */}
      </section> 
    </div>
  );
}

export default NavBar;
